import {
  CREATE_ROLE_FAIL,
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  FETCH_ROLE_FAIL,
  FETCH_ROLE_REQUEST,
  FETCH_ROLE_SUCCESS,
} from "../../ActionType/RoleType/RoleType";

export const getRoleReducer = (
  state = { loading: true, roles: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_ROLE_REQUEST:
      return {
        loading: true,
        roles: [],
        total: 0,
      };
    case FETCH_ROLE_SUCCESS:
      return {
        loading: false,
        roles: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case FETCH_ROLE_FAIL:
      return {
        loading: false,
        roles: [],
        total: 0,
        error: "",
      };
    default:
      return state;
  }
};

export const createRoleReducer = (
  state = { loading: true, roles: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case CREATE_ROLE_REQUEST:
      return {
        loading: true,
        roles: [],
        total: 0,
      };
    case CREATE_ROLE_SUCCESS:
      return {
        loading: false,
        roles: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case CREATE_ROLE_FAIL:
      return {
        loading: false,
        roles: [],
        total: 0,
        error: "",
      };
    default:
      return state;
  }
};
